import React, { useState } from "react";
import "../../Assets/styles/TopSection.css";
import logo from "../../Assets/images/md.png";
import heroImage from "../../Assets/images/magui-diogo.png";

const handleNavClick = (e, targetId) => {
  e.preventDefault();
  const section = document.querySelector(targetId);
  if (section) {
    section.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

const TopSection = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen((v) => !v);

  const NAV_LINKS = (
    <>
      <a href="#timeline" onClick={(e) => handleNavClick(e, "#timeline")}>
        A nossa história
      </a>
      <a href="#details" onClick={(e) => handleNavClick(e, "#details")}>
        Detalhes e Localização
      </a>
      <a href="#accommodation" onClick={(e) => handleNavClick(e, "#accommodation")}>
        Alojamento
      </a>
      <a href="#honeymoon" onClick={(e) => handleNavClick(e, "#honeymoon")}>
        Lua de Mel
      </a>
      <a href="#rsvp" onClick={(e) => handleNavClick(e, "#rsvp")}>
        RSVP
      </a>
    </>
  );

  return (
    <section className="top-section" aria-label="Hero">
      <img
        src={heroImage}
        alt="Margarida e Diogo"
        className="top-section-bg"
      />

      <div className="top-nav">
        <div className="top-nav-inner">
          <div className="top-nav-brand">
            <img src={logo} alt="Margarida e Diogo" className="nav-logo" />
          </div>

          <div className="top-nav-links">{NAV_LINKS}</div>

          <button
            type="button"
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={toggleMenu}
            aria-label="Menu"
            aria-expanded={menuOpen}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>

      <div className={`menu ${menuOpen ? "open" : ""}`} onClick={() => setMenuOpen(false)}>
        {NAV_LINKS}
      </div>

      <div className="hero-content">
        <h1 className="hero-names">Margarida e Diogo</h1>
        <p className="hero-subtitle">O NOSSO DIA ESTÁ A CHEGAR</p>

        <div className="date-display">
          <span>14</span><span>·</span><span>08</span><span>·</span><span>2026</span>
        </div>
      </div>
    </section>
  );
};

export default TopSection;